"use strict";
/* globals module */
/**
 * @module calendarEventRsvpBatchRoute
 * @description BaasicCalendarEventRsvpBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var CalendarEventRsvpBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpBatchRoute, _super);
    function CalendarEventRsvpBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-rsvp-details/batch';
        _this.updateRoute = 'calendar-rsvp-details/batch';
        _this.deleteRoute = 'calendar-rsvp-details/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.create();
     */
    CalendarEventRsvpBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.update();
     */
    CalendarEventRsvpBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.delete();
     */
    CalendarEventRsvpBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpBatchRoute);
    return CalendarEventRsvpBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpBatchRoute = CalendarEventRsvpBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
